export default __webpack_public_path__ + "static/media/playlist-pause-icon.87277eca.svg";